import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
// eslint-disable-next-line import/order
import { UzurvRestConfiguration, UzurvRestService, UZURV_REST_CONFIGURATION } from '@uzurv/http';
import { Deserialize, Serialize } from 'cerialize';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { FavoriteLocation, Location } from '../../models';

@Injectable({
  providedIn: 'root'
})
export class FavoriteLocationService extends UzurvRestService {
  constructor(
    httpClient: HttpClient,
    @Inject(UZURV_REST_CONFIGURATION)
    protected uzurvRestConfiguration: UzurvRestConfiguration,
    domSanitizer: DomSanitizer
  ) {
    super(httpClient, uzurvRestConfiguration, domSanitizer);
  }

  /**
   * Creates a favorite location for a rider
   *
   * @param userId
   * @param label
   * @param location
   */
  createFavoriteLocation(userId: number, label: string, location: Location): Observable<FavoriteLocation> {
    return this.post(`riders/${userId}/favoriteLocations/?label=${label}`, location).pipe(
      map(response => Deserialize(response, FavoriteLocation))
    );
  }

  /**
   * Updates a favorite location for a rider
   *
   * @param favoriteLocation
   */
  updateFavoriteLocation(favoriteLocation: FavoriteLocation): Observable<FavoriteLocation> {
    return this.put(`users/${favoriteLocation.riderId}/favoriteLocations/${favoriteLocation.id}`, Serialize(favoriteLocation)).pipe(
      map(response => Deserialize(response, FavoriteLocation))
    );
  }
}
